/*
 * action types
 */

export const TOGGLE_TERMS_AND_CONTDITIONS = 'TOGGLE_TERMS_AND_CONTDITIONS'
export const EXPAND_TERMS_AND_CONTDITIONS = 'EXPAND_TERMS_AND_CONTDITIONS'

export const RESET_GAMES_LEGAL_LINES = 'RESET_GAMES_LEGAL_LINES'
export const ADD_GAME_LEGAL_LINE = 'ADD_GAME_LEGAL_LINE'

export const UPDATE_BINGO_FEED_DATA = 'UPDATE_BINGO_FEED_DATA'

export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'

/*
 * action creators
 */

export function toggleTermsAndConditions () {
  return { type: TOGGLE_TERMS_AND_CONTDITIONS }
}

export function expandTermsAndConditions () {
  return { type: EXPAND_TERMS_AND_CONTDITIONS }
}

export function resetGamesLegalLines () {
  return { type: RESET_GAMES_LEGAL_LINES }
}

export function addGameLegalLine (legalLine) {
  return {
    type: ADD_GAME_LEGAL_LINE,
    legalLine
  }
}

export function updateBingoLobbyFeedData (data) {
  return {
    type: UPDATE_BINGO_FEED_DATA,
    data
  }
}

export function openStateModal (data) {
  return { type: OPEN_MODAL, data }
}

export function closeStateModal () {
  return { type: CLOSE_MODAL }
}
